import { useDispatch } from "react-redux";
import { FormIcon } from "./Form/FormIcon";
import { FormImage } from "./Form/FormImage";
import { FormImageList } from "./Form/FormImageList";
import { FormLink } from "./Form/FormLink";
import { FormList } from "./Form/FormList";
import { FormNumber } from "./Form/FormNumber";
import { FormNumList } from "./Form/FormNumList";
import { FormSwitch } from "./Form/FormSwitch";
import { FormText } from "./Form/FormText";
import { FormTexterea } from "./Form/FormTexterea";
import { setSectionData } from "../Redux/Slices/sectionSlice";
import { formNames } from "./FormNames";
import { Link } from "react-router-dom";
import { FormButton } from "./Form/FormButton";

function maker(type: any,key:any,name:any,value:any,i:number,input:any,change:any,url:string){
    switch (type) {
        case "txt":
            return <FormText _key={key} name={name} value={value} input={input} key={i} change={change}/>

        case "num":
            return <FormNumber _key={key} name={name} value={value} input={input} key={i} change={change}/>

        case "ico":
            return <FormIcon _key={key} name={name} value={value} input={input} key={i} change={change}/>

        case "btn":
            return <FormButton _key={key} name={name} value={value} input={input} key={i} change={change}/>
        
        case "txe":
            return <FormTexterea _key={key} name={name} value={value} input={input} key={i} change={change}/>
        
        case "swh":
            return <FormSwitch _key={key} name={name} value={value} input={input} key={i} change={change}/>
        
        case "lst":
            return <FormList _key={key} name={name} value={value} input={input} key={i} change={change}/>

        case "lsn":
            return <FormNumList _key={key} name={name} value={value} input={input} key={i} change={change}/>

        case "img":
            return <FormImage _key={key} name={name} value={value} input={input} key={i} change={change} url={url}/>

        case "lnk":
            return <FormLink _key={key} name={name} value={value} input={input} key={i} change={change}/>

        case "mdl":
            return <div className="d-grid"><Link className="btn btn-outline-primary" to={`/${key}`}>{name}</Link></div>

        case "lsi":
            const images = []
            images[0] = <hr/>
            images[1] = <label className="form-label">{name}</label>
            value.map((val:any,i:number) => 
                // images[i+2] = <FormImageList value={val} index={i} input={input} key={i} change={change} url={url}/>
                images[i+2] = <FormImageList _key={key} index={i} name={name} value={val} input={input} key={i} change={change} url={url}/>
            )
            return images
                
        case "obj":
            const ele = []
            ele[0] = <hr/>
            ele[1] = <label htmlFor="basic-url" className="form-label">{name}</label>
                Object.entries(value).map(([ke,val],i) => 
                    ele[i+2] = maker(ke.split("_")[0],ke.split("_")[1],formNames(ke.split("_")[1]),val,i,`${input}:${ke}`,change,url)
                )
            return ele

        case "lso":
            const ele2 = []
            ele2[0] = <label htmlFor="basic-url" className="form-label">{name}</label>
            value.map(function(arrval:any,arrindex:number) {
                const ele1 = []
                Object.entries(arrval).map(([ke,val],i) => 
                    ele1[i+1] = maker(ke.split("_")[0],ke.split("_")[1],formNames(ke.split("_")[1]),val,i,`${input}:${arrindex}:${ke}`,change,url)
                )
                ele1.push(<hr/>)
                return ele2[arrindex+1] = ele1
            }
            ) 
            return ele2

        default:
            return <></>
    }
}


export default function DataSelect({node,url}:any) {
    const dispatch = useDispatch()
    const handleChange = ({ target: { name, value ,checked }} : React.ChangeEvent<HTMLInputElement> | any) =>
        dispatch(setSectionData(name.includes('swh') ? { name , checked } : { name , value }))
        
    let elements:any = []
    if(node){
        Object.entries(node).map(([key, value],index) => 
            elements[index] = maker(key.split("_")[0],key.split("_")[1],formNames(key.split("_")[1]),value,index,key,handleChange,url)
        )
    }
    
    return (elements)
}